import { z } from 'zod';
import { BaseUserDTOSchema } from "./users.dto.js";
export const FindUsersInputDTOSchema = z.object({
    userType: z.enum(['staff', 'tenant', 'integrator']).optional(),
    companyId: z.string().uuid().optional(),
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(20),
});
export const FindUsersOutputDTOSchema = z.object({
    users: z.array(BaseUserDTOSchema),
    total: z.number(),
    page: z.number(),
    limit: z.number(),
});
//# sourceMappingURL=find-users.dto.js.map